export enum DynamicTextContextEnum {
    ConcernEntry = "ConcernEntry",
    IncidentEntry = "IncidentEntry",
    ContributionEntry = "ContributionEntry",
    Entry = "Entry",
    Event = "Event",
    Group = "Group",
    Template = "Template",
}
